import React from 'react';
import { useSelector } from 'react-redux';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import classNames from 'classnames';
import { selectHasFotofunBorder } from '../../_redux-borders';
import { selectisFotofunPanelOpen } from '../../_redux-ui';
import { FotoFunButton } from '../fotofun/components/FotoFunButton';
import { FotofunPanel } from '../fotofun/FotofunPanel';
import { PhotoPrintsOrderButton } from '../PhotoPrintsOrderButton';
import { PhotoPrintsWindowErrors } from '../PhotoPrintsWindowErrors';
import { PhotoPrintGroupsList } from './PhotoPrintGroupsList';
import styles from './PhotoPrintsWindowMobile.module.scss';

export const PhotoPrintsWindowMobile = ({ close }: Props) => {

    const hasFotofunBorder = useSelector(selectHasFotofunBorder);
    const isFotofunPanelOpen = useSelector(selectisFotofunPanelOpen);

    const windowBodyClassName = classNames({
        [styles.windowBodyWithFotofunPanel]: isFotofunPanelOpen
    });

    return (
        <Window fullHeight fullWidth close={close}>
            <div className={styles.windowHeaderWrapper}>
                {hasFotofunBorder && <FotoFunButton />}
                <WindowHeader className={styles.header} onClose={close} />
            </div>
            <WindowBody className={windowBodyClassName}>
                <PhotoPrintGroupsList />
            </WindowBody>
            {hasFotofunBorder && <FotofunPanel />}
            <PhotoPrintsWindowErrors />
            <WindowFooter>
                <PhotoPrintsOrderButton className={styles.orderButton} />
            </WindowFooter>
        </Window>
    );
};

type Props = {
    close: () => void;
};